export type BleFailureReason =
  | { type: 'bluetoothNotOn' }
  | { type: 'scanTimeout' }
  | { type: 'unknown'; cause: unknown }

export const bleBluetoothNotOn = (): BleFailureReason => ({
  type: 'bluetoothNotOn',
})
export const bleScanTimeout = (): BleFailureReason => ({ type: 'scanTimeout' })
export const bleUnknownFailure = (cause: unknown): BleFailureReason => ({
  type: 'unknown',
  cause,
})
